export default class Config {
}
Config.appName = 'Elecfes - Cuadrante';
Config.user_cookie = 'user_elecfes_cuadrante';
